import { render, staticRenderFns } from "./audioplayer.vue?vue&type=template&id=b9ae16c6&scoped=true&"
import script from "./audioplayer.vue?vue&type=script&lang=js&"
export * from "./audioplayer.vue?vue&type=script&lang=js&"
import style0 from "./audioplayer.vue?vue&type=style&index=0&id=b9ae16c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ae16c6",
  null
  
)

component.options.__file = "audioplayer.vue"
export default component.exports